module.exports = "/_next/static/images/macpunks-1-29688511ded579abaaa945b087dec8e5.png";